import { useEffect, useState } from 'react';

import Button from '@/components/Button';
import ButtonCircle from '@/components/ButtonCircle';
import { type PageFeedbackProps } from './PageFeedback.types';

const handleFeedbackSubmit = (pageId, positive, comments) => {
  // save feedback to local storage
  localStorage.setItem(
    `pageFeedback${pageId}`,
    JSON.stringify({
      comments,
      positive,
    })
  );

  fetch('/form/saveFeedback', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      pageId,
      positive,
      comments,
    }),
  });
};

const PageFeedback: React.FC<PageFeedbackProps> = ({ pageId }) => {
  const saved = localStorage.getItem(`pageFeedback${pageId}`);

  const [feedbackCompleted, setFeedbackCompleted] = useState(false);
  const [showFeedbackComments, setShowFeedbackComments] = useState(false);
  const [comments, setComments] = useState('');
  const [positive, setPositive] = useState(false);

  useEffect(() => {
    if (saved) {
      setFeedbackCompleted(true);
      setShowFeedbackComments(false);
    }
  }, [saved]);

  if (!pageId) {
    return null;
  }

  if (feedbackCompleted === true) {
    return (
      <div className="page-feedback">
        <div className="page-feedback__inner page-feedback__inner--form page-feedback__inner--completed">
          <h2 className="h5">Thank you for your feedback</h2>

          {showFeedbackComments && (
            <form
              onSubmit={(e) => {
                e.preventDefault();

                setFeedbackCompleted(true);
                setShowFeedbackComments(false);
                handleFeedbackSubmit(pageId, positive, comments);
              }}
            >
              <label>What could we be doing better?</label>
              <textarea
                value={comments}
                onChange={(e) => {
                  setComments(e.target.value);
                }}
              />
              <Button type="submit" primary>
                Submit <ButtonCircle arrowHeight={40} arrowWidth={40} />
              </Button>
            </form>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="page-feedback">
      <div className="page-feedback__inner">
        <h2 className="h5">Was this article helpful?</h2>

        <div className="page-feedback__buttons">
          <Button
            primary
            small
            textOnly
            onClick={() => {
              setPositive(true);
              setFeedbackCompleted(true);
              setShowFeedbackComments(false);
              handleFeedbackSubmit(pageId, true, '');
            }}
          >
            Yes
          </Button>
          <Button
            primary
            small
            textOnly
            onClick={() => {
              setShowFeedbackComments(true);
              setFeedbackCompleted(true);
              setPositive(false);
            }}
          >
            No
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PageFeedback;
